import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import CustomTableContainer from "../../unit/CustomTableContainer";
import formatDate from "../../unit/formatDate";
const TableCellRight = styled(TableCell)({ textAlign: "right" });

const CustomSummaryHmScoreList = ({ ...props }) => {
  const userId = props.userId;
  const data = props.data ? props.data : [];

  return (
    <div key={"hmscore_" + userId}>
      <CustomTableContainer component={CustomPaper}>
        <CustomTable
          key={"hmscore_table" + userId}
          stickyHeader
          id="table-customer-summary-hmscore-list"
        >
          <TableHead>
            <TableRow>
              <TableCell className="hm-table-header">
                Income Stability
              </TableCell>
              <TableCell className="hm-table-header">Income Level</TableCell>
              <TableCell className="hm-table-header">Spending Mix</TableCell>
              <TableCell className="hm-table-header">
                Spending within Means
              </TableCell>
              <TableCell className="hm-table-header">
                Spending Stability
              </TableCell>
              <TableCell className="hm-table-header">
                Saving Depository MDB
              </TableCell>
              <TableCell className="hm-table-header">Saving NSF</TableCell>
              <TableCell className="hm-table-header">
                Saving Credit MDB
              </TableCell>
              <TableCell className="hm-table-header">
                Saving Safetynet
              </TableCell>
              <TableCell className="hm-table-header">Financial IQ</TableCell>
              <TableCell className="hm-table-header">Total Score</TableCell>
              <TableCell className="hm-table-header">Calculated Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data == undefined || data.length == 0 || data == null ? (
              <TableRow>
                <TableCell colSpan={8}>No Transaction account </TableCell>
              </TableRow>
            ) : (
              data?.map((item: any) => (
                <TableRow key={`hmtr_` + item.id}>
                  <TableCell>{item.fIncomeStability}</TableCell>
                  <TableCell>{item.income_level}</TableCell>
                  <TableCell>{item.spending_mix}</TableCell>
                  <TableCell>{item.spending_within_means}</TableCell>
                  <TableCell>{item.spending_stability}</TableCell>
                  <TableCell>{item.savings_net_asset_mdb}</TableCell>
                  <TableCell>{item.savings_net_asset_nsf}</TableCell>
                  <TableCell>{item.savings_net_credit_mdb}</TableCell>
                  <TableCell>{item.savings_net_safety}</TableCell>
                  <TableCell>{item.financial_iq}</TableCell>
                  <TableCell>{item.total_score}</TableCell>
                  <TableCell sx={{ width: "120px" }}>
                    {formatDate(item.calculated_time)}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </div>
  );
};

export default CustomSummaryHmScoreList;
